import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, FieldArray, Field } from 'formik';
import { Space, Button, Form, Alert, Radio, Divider, Row, Col, Tooltip, Upload, Input, Modal, Collapse, Tabs, Popover } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import * as Yup from 'yup';

import * as constants from '../constants';
import {
    setSelectedDetailActivityIsDirty
} from '../actions';
import InformationCarriersGrid from './informationcarriers/InformationCarriersGrid';
import RecipientsGrid from './recipients/RecipientsGrid';
import LegalGroundsGrid from './legalgrounds/LegalGroundsGrid';
import ProcessedDataGrid from './processeddata/ProcessedDataGrid';
import TooltipInfoCarrier from './TooltipInfoCarrier';

import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import core from '../../core';
import dossier from '../../dossier';
import changelog from '../../changelog';

const { SelectInput, TextInput, TextArea, CheckboxInput, DatePickerInput, TextInputSelect, NumberInput, PersonsGrid, DisplayFormikState } = core;
const { DossierFilesGrid } = dossier
const { ChangelogGrid } = changelog

const FormItem = Form.Item;
const { Panel } = Collapse;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 6,
        },
    },
};


class NewActivityForm extends Component {

    state = {

    }

    async UNSAFE_componentWillMount() {

    }

    onCancel = async () => {
        this.props.onCancel();
    }

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            try {
                await this.props.onSave(values);
                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);
                setErrors();
            }
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'NewActivityForm', key);
    }

    FormSchema = () => {
        let schema = Yup.object().shape({
            processingActivity: Yup.object().shape({
                name: Yup.string().required('*'),
                idPrivacyOfficer: Yup.number().integer().required('*'),
                idCompany: Yup.number().integer().required('*'),
                responsiblePersonDep: Yup.string().required('*'),
                responsiblePerson: Yup.string().required('*'),
                businessProcess: Yup.string().required('*'),
                purpose: Yup.string().required('*'),
                categoryDataSubjects: Yup.string().required('*'),
                sourceOfData: Yup.string().required('*'),
            })
        })

        return schema;
    }

    CreateForm = (props) => {
        return (
            <Form layout='horizontal' style={{ margin: 10, maxHeight: this.props.contentheight - 10, overflowY: 'auto', overflowX: 'hidden' }}>
                <TextInput {...props} name="processingActivity.name" label={this.label("Name")} formItemLayout={formItemLayout} />
                <TextInput {...props} name="processingActivity.responsiblePersonDep" label={this.label("ResponsiblePersonDepartment")} formItemLayout={formItemLayout} />
                <TextInputSelect {...props} name="processingActivity.responsiblePerson" backingIdField="processingActivity.idResponsiblePerson"
                    searchModalTitle={this.label("SearchPerson")} modalwidth='70%' SearchControl={(callback, callback2) => { return <PersonsGrid onSelect={callback} onDoubleClick={callback2} /> }}
                    readOnly={true}
                    label={this.label("ResponsiblePerson")}
                    formItemLayout={formItemLayout}
                    showDelete={false}
                />
                <SelectInput {...props} name="processingActivity.idCompany" nameField="name" idField="id" items={this.props.picklists.allCompanies} label={this.label("Company")} formItemLayout={formItemLayout} />
                {/* <DatePickerInput {...props} name="processingActivity.reviewDate" showTime={false} label={this.label("ReviewDate")} placeholder={this.label("DatePlaceholder")} formItemLayout={formItemLayout} /> */}
                <TextInput {...props} name="processingActivity.businessProcess" label={this.label("BusinessProcess")} formItemLayout={formItemLayout} />

                <SelectInput {...props} name="processingActivity.idPrivacyOfficer" nameField="name" idField="id" items={this.props.picklists.privacyOfficers} label={this.label("PrivacyOfficer")} formItemLayout={formItemLayout} />

                <FieldArray name="legalGrounds"
                    render={arrayHelpers => (
                        <FormItem label={this.label("LegalGrounds")} {...formItemLayout}>
                            <LegalGroundsGrid idProcessingActivity={-1} arrayHelper={arrayHelpers} items={props.values.legalGrounds.map((line, index) => { return { ...line, idx: index } })} />
                        </FormItem>
                    )}
                />


                <TextArea {...props} name="processingActivity.specificationLegalGround" label={this.label("SpecificationLegalGround")} rows={3} formItemLayout={formItemLayout} />
                <TextArea {...props} name="processingActivity.purpose" label={this.label("Purpose")} rows={3} formItemLayout={formItemLayout} />
                <TextArea {...props} name="processingActivity.categoryDataSubjects" label={this.label("CategoryDataSubjects")} rows={3} formItemLayout={formItemLayout} />
                <TextInput {...props} name="processingActivity.sourceOfData" label={this.label("SourceOfData")} formItemLayout={formItemLayout} />

                <FieldArray name="informationCarriers"
                    render={arrayHelpers => (
                        <FormItem label={<>{this.label("InformationCarriers")} <Popover placement="rightTop" content={<TooltipInfoCarrier />} trigger="hover"><InfoCircleOutlined style={{padding: 10}} /></Popover> </>} {...formItemLayout}>
                            <InformationCarriersGrid idProcessingActivity={-1} arrayHelper={arrayHelpers} items={props.values.informationCarriers.map((line, index) => { return { ...line, idx: index } })} />
                        </FormItem>
                    )}
                />

                <FieldArray name="processedData"
                    render={arrayHelpers => (
                        <FormItem label={this.label("ProcessedData")} {...formItemLayout}>
                            <ProcessedDataGrid idProcessingActivity={-1} arrayHelper={arrayHelpers} items={props.values.processedData.map((line, index) => { return { ...line, idx: index } })} />
                        </FormItem>
                    )}
                />

                <CheckboxInput {...props} name="processingActivity.hasDataProcessor" label={this.label("HasDataProcessor")} formItemLayout={formItemLayout} />
                {props.values.processingActivity.hasDataProcessor &&
                    <TextInput {...props} name="processingActivity.dataProcessorName" label={this.label("DataProcessorName")} formItemLayout={formItemLayout} />
                }
                <CheckboxInput {...props} name="processingActivity.processingAgreement" label={this.label("ProcessingAgreement")} formItemLayout={formItemLayout} />
                <SelectInput {...props} name="processingActivity.idCountry" nameField="namePlus" idField="id" items={this.props.picklists.countries} label={this.label("Country")} formItemLayout={formItemLayout} />

                <CheckboxInput {...props} name="processingActivity.dpiaRequired" label={this.label("DpiaRequired")} formItemLayout={formItemLayout} />
                <CheckboxInput {...props} name="processingActivity.dpiaPerformed" label={this.label("DpiaPerformed")} formItemLayout={formItemLayout} />
                <DatePickerInput {...props} name="processingActivity.dpiaDate" showTime={false} label={this.label("DpiaDate")} placeholder={this.label("DatePlaceholder")} formItemLayout={formItemLayout} />
                {/* <TextInput {...props} name="processingActivity.dpiaReference" label={this.label("DpiaReference")} formItemLayout={formItemLayout} /> */}

                <FieldArray name="recipients"
                    render={arrayHelpers => (
                        <FormItem label={this.label("Recipients")} {...formItemLayout}>
                            <RecipientsGrid idProcessingActivity={-1} arrayHelper={arrayHelpers} items={props.values.recipients.map((line, index) => { return { ...line, idx: index } })} />
                        </FormItem>
                    )}
                />
                <Divider />
                <FormItem {...tailFormItemLayout} >
                    <Space.Compact>
                        <Button size='small' type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || this.props.readOnly} > {this.label("Save")} </Button>
                        <Button size='small' disabled={props.isSubmitting || this.props.readOnly} onClick={this.onCancel}>{this.label("Cancel")} </Button>
                    </Space.Compact>
                    {props.isSubmitting &&
                        <Alert
                            message={this.label("Saving")}
                            style={{ marginTop: 20 }}
                        />
                    }
                </FormItem>

                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true} validateOnBlur={false} validateOnChange={false}
                initialValues={this.props.datacontext}
                validationSchema={this.FormSchema()}
                onSubmit={this.onSave}
                innerRef={p => (this.formik = p)}
            >
                {(props) => this.CreateForm(props)}
            </Formik>
        );
    }
}
function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}


export default connect(mapStateToProps, {
    setSelectedDetailActivityIsDirty,
})(NewActivityForm);


